/**
 * Estados do Brasil pelos dois primeiros dígitos do código do IBGE do município: sigla, nome,
 * nome com a preposição em português ("no Paraná", "em Santa Catarina") e a capital, que dá
 * nome à região na Home ("Curitiba e região").
 */
export interface BrazilState {
  uf: string;
  name: string;
  /** "no Paraná", "na Bahia", "em Santa Catarina" (só português). */
  inPt: string;
  /** Código do IBGE da capital. */
  capital: number;
}

export const BRAZIL_STATES: Record<string, BrazilState> = {
  '11': { uf: 'RO', name: 'Rondônia', inPt: 'em Rondônia', capital: 1100205 },
  '12': { uf: 'AC', name: 'Acre', inPt: 'no Acre', capital: 1200401 },
  '13': { uf: 'AM', name: 'Amazonas', inPt: 'no Amazonas', capital: 1302603 },
  '14': { uf: 'RR', name: 'Roraima', inPt: 'em Roraima', capital: 1400100 },
  '15': { uf: 'PA', name: 'Pará', inPt: 'no Pará', capital: 1501402 },
  '16': { uf: 'AP', name: 'Amapá', inPt: 'no Amapá', capital: 1600303 },
  '17': { uf: 'TO', name: 'Tocantins', inPt: 'no Tocantins', capital: 1721000 },
  '21': { uf: 'MA', name: 'Maranhão', inPt: 'no Maranhão', capital: 2111300 },
  '22': { uf: 'PI', name: 'Piauí', inPt: 'no Piauí', capital: 2211001 },
  '23': { uf: 'CE', name: 'Ceará', inPt: 'no Ceará', capital: 2304400 },
  '24': { uf: 'RN', name: 'Rio Grande do Norte', inPt: 'no Rio Grande do Norte', capital: 2408102 },
  '25': { uf: 'PB', name: 'Paraíba', inPt: 'na Paraíba', capital: 2507507 },
  '26': { uf: 'PE', name: 'Pernambuco', inPt: 'em Pernambuco', capital: 2611606 },
  '27': { uf: 'AL', name: 'Alagoas', inPt: 'em Alagoas', capital: 2704302 },
  '28': { uf: 'SE', name: 'Sergipe', inPt: 'em Sergipe', capital: 2800308 },
  '29': { uf: 'BA', name: 'Bahia', inPt: 'na Bahia', capital: 2927408 },
  '31': { uf: 'MG', name: 'Minas Gerais', inPt: 'em Minas Gerais', capital: 3106200 },
  '32': { uf: 'ES', name: 'Espírito Santo', inPt: 'no Espírito Santo', capital: 3205309 },
  '33': { uf: 'RJ', name: 'Rio de Janeiro', inPt: 'no Rio de Janeiro', capital: 3304557 },
  '35': { uf: 'SP', name: 'São Paulo', inPt: 'em São Paulo', capital: 3550308 },
  '41': { uf: 'PR', name: 'Paraná', inPt: 'no Paraná', capital: 4106902 },
  '42': { uf: 'SC', name: 'Santa Catarina', inPt: 'em Santa Catarina', capital: 4205407 },
  '43': { uf: 'RS', name: 'Rio Grande do Sul', inPt: 'no Rio Grande do Sul', capital: 4314902 },
  '50': { uf: 'MS', name: 'Mato Grosso do Sul', inPt: 'em Mato Grosso do Sul', capital: 5002704 },
  '51': { uf: 'MT', name: 'Mato Grosso', inPt: 'em Mato Grosso', capital: 5103403 },
  '52': { uf: 'GO', name: 'Goiás', inPt: 'em Goiás', capital: 5208707 },
  '53': { uf: 'DF', name: 'Distrito Federal', inPt: 'no Distrito Federal', capital: 5300108 },
};

export function stateOf(ibgeCode: number): BrazilState | undefined {
  return BRAZIL_STATES[String(ibgeCode).slice(0, 2)];
}

export const CAPITAL_CODES = new Set(Object.values(BRAZIL_STATES).map((s) => s.capital));
